import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Dialog, {
  DialogActions,
  DialogContent,
  DialogTitle,
} from 'components/common/Dialog';

import { change, isSubmitting, isValid, getFormValues } from 'redux-form';

import documents from 'config/documents';

import Button from 'components/common/Button';
import CMNSelectionForm from './CMNSelectionForm';

const styles = theme => ({
  form: {
    padding: '40px 60px 40px',
    [theme.breakpoints.down('sm')]: {
      padding: '16px 8px 16px',
    },
  },
});

const CMNSelectionDialog = ({
  form,
  open,
  onClose,
  onClear,
  onSubmitSuccess,
  initialValues,
  formValues,
  valid,
  actions,
  onPrintEditPreviewButtonClick,
  classes,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="sm"
  >
    <DialogTitle
      onCloseClick={onClose}
    >
      <Typography
        variant="title"
        color="secondary"
        align="center"
      >
        Choose the CMN type
      </Typography>
    </DialogTitle>
    <DialogContent>
      <CMNSelectionForm
        className={classes.form}
        form={form}
        initialValues={initialValues}
        onSubmitSuccess={(values) => {
          onClose();
          onSubmitSuccess(values);
        }}
      />
    </DialogContent>
    <DialogActions>
      <Button
        onClick={() => {
          actions.change(form, 'CMN/AMB', '');
        }}
        variant="raised"
      >
        Clear
      </Button>
      <Button
        onClick={() => {
          const selectedCMN = documents.find(item => item.Name === formValues['CMN/AMB']);
          if (selectedCMN) {
            onPrintEditPreviewButtonClick({
              documentID: selectedCMN.ID,
            });
            onClose();
          } else {
            onClear();
            onClose();
          }
        }}
        variant="raised"
        color="primary"
        disabled={!valid}
      >
        Save
      </Button>
    </DialogActions>
  </Dialog>
);

CMNSelectionDialog.propTypes = {
  open: PropTypes.bool,
  form: PropTypes.string.isRequired,
  onClose: PropTypes.func,
  onClear: PropTypes.func,
  onSubmitSuccess: PropTypes.func,
  valid: PropTypes.bool.isRequired,
  initialValues: PropTypes.shape({
    'CMN/AMB': PropTypes.string,
  }),
  formValues: PropTypes.shape({
    'CMN/AMB': PropTypes.string,
  }),
  onPrintEditPreviewButtonClick: PropTypes.func,
  classes: PropTypes.shape({
    form: PropTypes.string.isRequired,
  }).isRequired,
};

CMNSelectionDialog.defaultProps = {
  open: false,
  initialValues: {},
  onClose: () => {},
  onClear: () => {},
  onSubmitSuccess: () => {},
  formValues: {},
  onPrintEditPreviewButtonClick: () => {},
};

const mapStateToProps = (store, ownProps) => ({
  submitting: isSubmitting(ownProps.form)(store),
  valid: isValid(ownProps.form)(store),
  formValues: getFormValues(ownProps.form)(store),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ change }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(CMNSelectionDialog),
);



// WEBPACK FOOTER //
// ./src/components/workflow/CMNSelectionDialog/CMNSelectionDialog.js